import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useI18n } from "../lib/i18n";
import api, { formatApiErrorDetail } from "../lib/api";
import { AuthField } from "./Login";

export default function ForgotPassword() {
    const { t } = useI18n();
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="bg-grain min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-4 py-20" data-testid="forgot-page">
                <h1 className="font-display text-4xl">{t.auth.forgotTitle}</h1>
                <p className="text-brand-text/70 mt-2">{t.auth.forgotSub}</p>
                {done ? (
                    <div className="mt-8 rounded-3xl border border-brand-border bg-white p-7 space-y-3" data-testid="forgot-done">
                        <div className="text-brand-success font-semibold">{t.auth.forgotDone}</div>
                        <Link to="/login" className="block text-center text-sm text-brand-primary pt-2">← {t.auth.login}</Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-8 space-y-4 rounded-3xl border border-brand-border bg-white p-7">
                        <AuthField label={t.auth.email} type="email" value={email} onChange={setEmail} testid="forgot-email" required />
                        {error && <div className="text-sm text-brand-critical">{error}</div>}
                        <button disabled={busy} type="submit" className="w-full py-3 rounded-full btn-primary font-semibold disabled:opacity-60" data-testid="forgot-submit">
                            {busy ? "..." : t.auth.forgotSend}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
